export const environment = {
  production: true,
  apiUrl: 'https://api.fluxtail.io/api',
  streamApiUrl: 'https://stream.fluxtail.io',
  mcpUrl: 'https://mcp.fluxtail.io/mcp',
  turnstileSiteKey: '0x4AAAAAAC98wYJRQpSpesbL',
  sentryDsn: 'https://18221eedbe5b8003a6734e748fafae48@o4506173594075136.ingest.us.sentry.io/4510445632749568',
  sentryEnvironment: 'production',
  sentryRelease: '',
  sentryTracesSampleRate: 0,
  sentryReplaySampleRate: 0,
  sentryReplayOnErrorSampleRate: 0,
  matomoUrl: '',
  matomoSiteId: '',
};
